<template>
  <div class="dish-chip-wrapper">
    <v-tooltip bottom :debounce="1">
      <v-chip
        slot="activator"
        :class="showRemoveIcon ? 'pr-4' : ''"
        disabled
        color="secondary"
        text-color="white"
      >
        <span :class="mobile ? 'dish-chip-mobile' : 'dish-chip'">{{ dish.title }}</span>
      </v-chip>
      <span>{{ hoverText }}</span>
    </v-tooltip>
    <v-icon v-if="showRemoveIcon" class="dish-chip-clear-icon" right @click="() => $emit('removeSelection', dish)">clear</v-icon>
  </div>
</template>

<script>
export default {
  name: 'DishChip',
  props: {
    dish: {
      type: Object,
      required: true,
    },
    editable: Boolean,
    dishesCount: {
      type: Number,
      default: undefined,
    },
    state: {
      type: String,
      required: true,
    },
    mobile: Boolean,
  },
  computed: {
    showRemoveIcon() {
      return this.editable && this.state !== 'loading';
    },
    hoverText() {
      return `${this.dish.title} ${this.dish.price > 0 ? `${this.dish.price.toFixed(2)} €` : ''}`;
    },
  },
};
</script>

<style scoped>
.dish-chip-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.dish-chip {
  max-width: 350px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.dish-chip-mobile {
  max-width: 200px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.dish-chip-clear-icon {
  position: absolute;
  right: 10px;
  color: white;
}
</style>
